<template>
<div>
  <div v-if="state !== -1" @click="clickWrap" class="wrapper" :style="loadVstyle">
    <p class="text">{{getText()}}</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'ModuleReload',
  props: {
    state: {
      type: Number,
      default: 0,
    },
    loadVstyle: {
      type: String,
      default: '',
    },
    click: {
      type: Function,
      default: () => {
      },
    },
  },
  methods: {
    getText() {
      if (this.state === 0) {
        return '信息加载中...';
      }
      // -1 隐藏   0 信息加载中...   1 加载失败, 点击重试
      return '网络不给力，请点击重试';
    },
    clickWrap() {
      if (this.state === 0 || this.state === -1) {
        return;
      }
      this.click();
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
    background-color: #ffffff;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.text {
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #999999;
    text-align: center;
}
</style>
